import { useState } from 'react';
import { Form, Input, message, Modal } from 'antd';
import {
  ControlOutlined,
  LockOutlined,
  LogoutOutlined,
  NotificationOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '@/stores/userStore';
import { authChangePassword } from '@/services/auth';
import styles from './ProfileTab.module.css';

function ProfileTab() {
  const navigate = useNavigate();
  const { userInfo, isAdmin, logout } = useUserStore();
  const [pwdOpen, setPwdOpen] = useState(false);
  const [pwdLoading, setPwdLoading] = useState(false);
  const [pwdForm] = Form.useForm();

  const displayName =
    userInfo?.realName || userInfo?.username || userInfo?.email || '用户';

  const handleLogout = () => {
    Modal.confirm({
      title: '确认退出',
      content: '确定要退出登录吗？',
      okText: '确定',
      okButtonProps: { danger: true },
      cancelText: '取消',
      onOk: () => {
        logout();
        message.success('已退出登录');
        navigate('/login', { replace: true });
      },
    });
  };

  const handlePasswordChange = async () => {
    try {
      const values = await pwdForm.validateFields();
      if (values.newPassword !== values.confirmPassword) {
        message.error('两次输入的新密码不一致');
        return;
      }
      setPwdLoading(true);
      await authChangePassword({
        identifier: userInfo?.id || userInfo?.email || userInfo?.phone || '',
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      });
      message.success('密码修改成功');
      setPwdOpen(false);
      pwdForm.resetFields();
    } catch { /* handled by interceptor */ } finally {
      setPwdLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.avatar}>
        <UserOutlined style={{ fontSize: 36 }} />
      </div>
      <div className={styles.name}>{displayName}</div>
      <div className={styles.userId}>ID · {userInfo?.id ?? 'N/A'}</div>
      {userInfo?.userType && (
        <div className={styles.badge}>{userInfo.userType}</div>
      )}

      <div className={styles.actions}>
        <button className={styles.action} onClick={() => setPwdOpen(true)}>
          <LockOutlined className={styles.actionIcon} />
          <span>修改 AdenPassport 密码</span>
        </button>

        {isAdmin && (
          <>
            <button
              className={styles.action}
              onClick={() => navigate('/control-center')}
            >
              <ControlOutlined className={styles.actionIcon} />
              <span>星舰控制中心</span>
            </button>
            <button
              className={styles.action}
              onClick={() => navigate('/broadcast-admin')}
            >
              <NotificationOutlined className={styles.actionIcon} />
              <span>星舰广播中心</span>
            </button>
          </>
        )}

        <button
          className={`${styles.action} ${styles.actionDanger}`}
          onClick={handleLogout}
        >
          <LogoutOutlined className={styles.actionIcon} />
          <span>退出登录</span>
        </button>
      </div>

      <Modal
        title="修改 AdenPassport 密码"
        open={pwdOpen}
        onOk={handlePasswordChange}
        onCancel={() => { setPwdOpen(false); pwdForm.resetFields(); }}
        okText="确认修改"
        cancelText="取消"
        confirmLoading={pwdLoading}
      >
        <Form form={pwdForm} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item
            name="oldPassword"
            label="当前密码"
            rules={[{ required: true, message: '请输入当前密码' }]}
          >
            <Input.Password placeholder="请输入当前密码" />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="新密码"
            rules={[
              { required: true, message: '请输入新密码' },
              { min: 6, message: '密码长度不能少于6位' },
            ]}
          >
            <Input.Password placeholder="请输入新密码" />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="确认新密码"
            rules={[{ required: true, message: '请再次输入新密码' }]}
          >
            <Input.Password placeholder="请再次输入新密码" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default ProfileTab;
